export default __webpack_public_path__ + "static/media/asrhmm.6ffa1b95.png";